import { ExchangeError } from '../../../errors.js';
const SERVER = new URL('https://api.changehero.io/v2');
const KEY = new Map([
    ['intl', 'cdb717a102b042d1a9e2ffec42678ca7'],
    ['us', 'ae63cd3b9fb245a883df0ef3c4d0607b'],
]);
const createGetChangeHeroOrder = (geolocation, fetchival) => {
    return async ({ message, sign }) => {
        const HEADERS = { 'api-key': KEY.get(geolocation) };
        const headers = {
            ...HEADERS,
            sign,
        };
        const response = await fetchival(SERVER, { headers }).post(message);
        if (!response?.result) {
            throw new ExchangeError({ message: JSON.stringify(response) });
        }
        return response.result[0];
    };
};
const createGetProviderOrder = (geolocation) => async (providerOrder, fetchival) => {
    if (!providerOrder.options?.statusRequestParams) {
        throw new ExchangeError({ message: 'Missing headers for ChangeHero' });
    }
    const orderInfo = await createGetChangeHeroOrder(geolocation, fetchival)(providerOrder.options.statusRequestParams);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.payinAddress,
        depositAmount: orderInfo.amountExpectedFrom,
        withdrawalAddress: orderInfo.payoutAddress,
    };
};
const changeHeroConfig = {
    he: createGetProviderOrder('intl'),
    heus: createGetProviderOrder('us'),
};
export default changeHeroConfig;
